import { Reducer } from 'redux';

import { Contact } from '@/controllers/ShippingAddress';
import { replaceNullWithEmptyString } from '@/utils/replace-null-with-empty-string';

import { ShippingAddressesActionTypes } from './action-types';
import { initialState } from './constants';
import { ShippingAddressesReducerState as State } from './types';

const format = (contacts: Contact[]): Contact[] =>
  contacts.map(({ eligibleEdit: _, ...contact }) => replaceNullWithEmptyString(contact));

export const shippingAddressesReducer: Reducer<State> = (state = initialState, action): State => {
  switch (action.type) {
    case ShippingAddressesActionTypes.FETCH_SHIPPING_ADDRESSES.SUCCESS:
      return {
        ...state,
        oldContacts: format(action.payload),
        newContacts: action.payload,
      };

    case ShippingAddressesActionTypes.UPDATE_SHIPPING_ADDRESS.SUCCESS: {
      const updatedShipmentInfo = action.sagaPayload.newShipmentInfo;
      const otherShipmentInfo = state.oldContacts.filter(
        info => info.contactId !== updatedShipmentInfo.contactId,
      );

      return {
        ...state,
        oldContacts: format([updatedShipmentInfo, ...otherShipmentInfo]),
      };
    }

    default:
      return state;
  }
};
